import React from 'react'
import PropTypes from 'prop-types'
import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const CardsPriceRange = ({amounts}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Text {...styles.rightBox.priceRange}>
            ${Math.min(...amounts)} - ${Math.max(...amounts)}
        </Text>
    )
}

CardsPriceRange.propTypes = {
    amounts: PropTypes.any
}

export default CardsPriceRange
